import React from "react"
import { Box, Stack } from "@mui/material"
import {
  BrandMark,
  TopMenuBar,
  type TopMenuBarItem,
} from "../molecules/TopMenuBar"
import { ViraIconButton } from "../atoms/ViraIconButton"
import { ViraIcon } from "../atoms/ViraIcon"

export type LoopNavItem = TopMenuBarItem

export type LoopHeaderProps = {
  navItems?: LoopNavItem[]
  /** @deprecated Account lives in the sidebar — do not pass. */
  practitionerName?: string
  /** @deprecated Account lives in the sidebar — do not pass. */
  onPractitionerClick?: () => void
  /** Opens mobile nav drawer (typically wired by `LoopShell`) */
  onNavMenuClick?: () => void
  /** Force-show the menu button; otherwise shown below `md` via CSS */
  showNavMenu?: boolean
}

const DEFAULT_NAV: LoopNavItem[] = [
  { id: "techniques", label: "My Techniques and Interventions" },
  { id: "org", label: "My Organization" },
  { id: "clients", label: "My Clients", active: true },
]

export function LoopHeader({
  navItems = DEFAULT_NAV,
  onNavMenuClick,
  showNavMenu,
}: LoopHeaderProps) {
  const menuVisible = showNavMenu ?? Boolean(onNavMenuClick)

  return (
    <Box
      component="header"
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        gap: { xs: 1, sm: 2 },
        px: { xs: 2, md: 3.5 },
        py: { xs: 1, sm: 0 },
        minHeight: { xs: 56, sm: 60 },
        bgcolor: "background.paper",
        borderBottom: "1px solid",
        borderColor: "divider",
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1} sx={{ minWidth: 0 }}>
        {menuVisible ? (
          <ViraIconButton
            variant="outlined"
            aria-label="Open navigation"
            onClick={onNavMenuClick}
            sx={{
              display: showNavMenu ? "inline-flex" : { xs: "inline-flex", md: "none" },
              width: 40,
              height: 40,
              flexShrink: 0,
            }}
          >
            <ViraIcon name="menu" tone="muted" />
          </ViraIconButton>
        ) : null}
        <BrandMark
          sx={{
            "& .MuiTypography-root": {
              fontSize: { xs: 20, sm: 25 },
            },
          }}
        />
      </Stack>

      <Box
        sx={{
          display: { xs: "none", md: "block" },
          minWidth: 0,
          overflow: "hidden",
        }}
      >
        <TopMenuBar items={navItems} />
      </Box>
    </Box>
  )
}
